import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AppStore from './stores';
import Notifier from './components/notifier';
import './i18n';

const publicBasePath = process.env.REACT_APP_PUBLIC_BASE_NAME;

ReactDOM.render(
  <Provider store={AppStore}>
    <BrowserRouter basename={publicBasePath}>
      <Notifier />
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
